<template>
  <div class="container-video">
    <div class="video">
      <h2>{{ lesson.title }}</h2>

      <iframe
        width="100%"
        height="520"
        :src="lesson.videoLink"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      >
      </iframe>

      <FormButtonGroup align="end" spaced>
        <FormButton
          text="Voltar"
          type="submissao"
          :rounded="false"
          @click="navigateSection('voltar')"
          v-show="!lesson.voltar && lesson.title"
        />

        <FormButton
          text="Avançar"
          type="primario"
          :rounded="false"
          @click="navigateSection('avancar')"
          v-show="lesson.title"
        />
      </FormButtonGroup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButton from "@/components/form/FormButton";

export default {
  data() {
    return {
      lesson: {
        id: "",
        title: "",
        videoLink: "",
        voltar: false
      }
    };
  },
  components: {
    FormButtonGroup,
    FormButton
  },
  computed: {
    ...mapGetters(["getVideosAcademy"]),
    sections() {
      return this.getVideosAcademy || [];
    }
  },
  methods: {
    sectionSelecionada(params) {
      const { sectionid } = params;
      return this.sections.find(video => video.idSection === sectionid) || null;
    },
    videoAtual(params) {
      const { lessonid } = params;
      const sectionAtual = this.sectionSelecionada(params);

      if (sectionAtual) {
        const posicaoVideo = sectionAtual.lessons.findIndex(
          lesson => lesson.id === lessonid
        );

        const lessonAtual = sectionAtual.lessons[posicaoVideo] || {};
        const isFirstVideoOfFirstSection =
          this.sections.indexOf(sectionAtual) === 0 && posicaoVideo === 0;

        this.lesson = {
          ...lessonAtual,
          voltar: isFirstVideoOfFirstSection
        };
      } else {
        this.lesson = {
          id: "",
          title: "",
          videoLink: "",
          voltar: false
        };
      }
    },
    buscarObjetoPaiPorId(id) {
      return (
        this.sections.find(
          item =>
            Array.isArray(item.lessons) &&
            item.lessons.some(subItem => subItem.id === id)
        ) || null
      );
    },
    navigateSection(acao) {
      const sectionAtual = this.buscarObjetoPaiPorId(this.lesson.id);
      if (!sectionAtual) return;

      const lessonsDaSeccao = sectionAtual.lessons;
      const posicaoVideo = lessonsDaSeccao.findIndex(
        lesson => lesson.id === this.lesson.id
      );

      const posicaoSeccaoAtual = this.sections.indexOf(sectionAtual);

      switch (acao) {
        case "voltar":
          if (posicaoVideo > 0) {
            const lessonAnterior = lessonsDaSeccao[posicaoVideo - 1];
            this.$router.push(
              `/ead/section/${sectionAtual.idSection}/lesson/${lessonAnterior.id}`
            );
          } else if (posicaoSeccaoAtual > 0) {
            const secaoAnterior = this.sections[posicaoSeccaoAtual - 1];
            if (secaoAnterior.evaluation) {
              this.$router.push(`/ead/section/${secaoAnterior.idSection}/test`);
            } else {
              const ultimoLesson =
                secaoAnterior.lessons[secaoAnterior.lessons.length - 1];
              this.$router.push(
                `/ead/section/${secaoAnterior.idSection}/lesson/${ultimoLesson.id}`
              );
            }
          }
          break;

        case "avancar":
          if (posicaoVideo < lessonsDaSeccao.length - 1) {
            const proximaLesson = lessonsDaSeccao[posicaoVideo + 1];
            this.$router.push(
              `/ead/section/${sectionAtual.idSection}/lesson/${proximaLesson.id}`
            );
          } else if (sectionAtual.evaluation) {
            this.$router.push(`/ead/section/${sectionAtual.idSection}/test`);
          } else if (posicaoSeccaoAtual < this.sections.length - 1) {
            const proximaSecao = this.sections[posicaoSeccaoAtual + 1];
            const primeiraLesson = proximaSecao.lessons[0];
            this.$router.push(
              `/ead/section/${proximaSecao.idSection}/lesson/${primeiraLesson.id}`
            );
          }
          break;
        default:
          break;
      }
    }
  },
  watch: {
    "$route.params": function(params) {
      if (this.getVideosAcademy && this.getVideosAcademy.length) {
        this.videoAtual(params);
      }
    },
    getVideosAcademy(newVal) {
      if (newVal && newVal.length) {
        this.videoAtual(this.$route.params);
      }
    }
  },
  created() {
    if (this.getVideosAcademy && this.getVideosAcademy.length) {
      this.videoAtual(this.$route.params);
    }
  }
};
</script>

<style scoped>
.container-video {
  width: 100%;
  display: flex;
  justify-content: center;
}

.container-video .video {
  width: 70%;
}

.container-video .video h2 {
  margin: 1em 0;
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #696a68;
}
</style>

<style lang="scss">
.v-application.theme--dark .container-video .video h2 {
  color: rgba(255, 255, 255, 0.87);
}
</style>
